var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.errors)?_c('b-alert',{staticClass:"mb-4 text-center",attrs:{"variant":"danger","id":"info","show":"","fade":""}},_vm._l((_vm.parsedErrors),function(error,index){return _c('p',{key:index,staticClass:"my-0",domProps:{"innerHTML":_vm._s(error)}})}),0):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }